import React, { Component } from 'react';
import './Card.css';
import Img from '../../StableImage';
import Library from '../../scene/utility/Library';

export default class Card extends Component {

  attackIcon () {

    let model = this.props.src.key ? this.props.src : this.props.src.model;
  	if (!model.states)
  		return "attack";
    let states = ["warden", "burst", "agility", "reach", "initiative", "drain"];
    for (let state in states)
      if (model.states.includes(states[state]))
        return states[state];
    
    return "attack";
  }

  healthIcon () {

    let model = this.props.src.key ? this.props.src : this.props.src.model;
  	if (!model.states)
  		return "heart";
    let states = ["shield", "undying", "exalted", "hidden", "ephemeral"];
    for (let state in states)
      if (model.states.includes(states[state]))
        return states[state];
    
    return "heart";
  }

	render () {

		if (!this.props.src)
			return <div className="gg-card no-select"><img className="card-back-img" alt="" src="/images/back.jpg"/></div>;

    let src = this.props.src;
    //let tier = this.props.tier || 0;
    let model = src.model || src;
    /*if (tier && model.upgrades)
      model = Object.assign({}, model, model.upgrades[tier-1]);*/
    let isEngine = src.engine || Library.hasSubtype(model, "engine");
    let mana = src.cost === undefined ? (src.mana === undefined ? undefined : Math.max(0, src.mana)) : src.cost;
    let manaBaseline = isEngine && src.master ? (src.master.enginesPlayed || 0) : model.mana;
    let manaClass = manaBaseline === undefined ? "" : (mana < manaBaseline ? " card-mana-buff" : (mana > manaBaseline ? " card-mana-debuff" : ""));

    let img = Library.getSelectedCardArt(model);

		return(
			<div className={"gg-card no-select champion-" + model.champion + "-card " + this.props.className}>
        <div className="card-image-placeholder">
          <div className="px"/><div className="px"/><div className="px"/><div className="px"/>
          <div className="px"/><div className="px"/><div className="px"/><div className="px"/>
          <div className="px"/><div className="px"/><div className="px"/><div className="px"/>
          <div className="px"/><div className="px"/><div className="px"/><div className="px"/>
        </div>
				<div className={"card-image-wrapper" + (mana === undefined ? " no-mana" : "")}>
					<Img key={model.key} alt="" src={img}/>
				</div>
        <div className={"card-mana" + manaClass}>{mana}</div>
        {/*<div className="card-level">{src.level}</div>*/}
				<div className="card-name"><div className="card-name-text">{model.name}</div></div>
        <Img key={"cardframe-" + model.rarity} className={"card-frame" + (mana === undefined ? " no-mana" : "")} alt="" src={"/images/frames/" + (src.golden ? "gold" : (model.rarity && model.rarity > 1 ? (model.rarity === 5 ? "dark" : (model.rarity === 4 ? "epic" : (model.rarity === 3 ? "rare" : "uncommon"))) : (model.starter ? "common" : "common"))) + (model.edge ? "-edge" : "")  + (model.subtypes?.includes("augment") ? "-augment" : "") + ".png"}/>
        { isEngine && <Img className="card-engine" src="/images/Engine.png"/> }
        { src.atk ? <div className="card-stat card-atk"><Img className="card-stat-icon" alt="" src={"/images/icons/" + this.attackIcon() + ".png"}/><div className={"card-stat-value" + (src.atk > model.atk ? " card-stat-value-buff" : "")}>{src.atk}</div></div> : "" }
        { src.charge ? <div className="card-stat card-atk"><Img className="card-stat-icon" alt="" src={"/images/icons/charge.png"}/><div className={"card-stat-value" + (src.charge > model.charge ? " card-stat-value-buff" : "")}>{src.charge}</div></div> : "" }
        { src.hp ? <div className="card-stat card-hp"><Img className="card-stat-icon" alt="" src={"/images/icons/" + this.healthIcon() + ".png"}/><div className={"card-stat-value" + (src.hp > model.hp ? " card-stat-value-buff" : "")}>{src.hp}</div></div> : "" }
			</div>
		);
	}
}
